import { render, staticRenderFns } from "./dashboardScrm.vue?vue&type=template&id=30c0ffeb"
import script from "./dashboardScrm.vue?vue&type=script&lang=js"
export * from "./dashboardScrm.vue?vue&type=script&lang=js"
import style0 from "./dashboardScrm.vue?vue&type=style&index=0&id=30c0ffeb&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports